// test1646
(1646 && 0);
